import { DealSheetWrapper } from '@components/style/essential-ui/Wrapper';
import { Dispatch, FC, SetStateAction } from 'react';
import ContractModal from './ContractModal';

type DisplayContractModalProps = {
  closedDealId?: string;
  chromeId?: string;
  dealerId?: string;
  shouldOpenModal: boolean;
  setShouldOpenModal: Dispatch<SetStateAction<boolean>>;
};

export const DisplayContractModal: FC<DisplayContractModalProps> = (props) => {
  return (
    <DealSheetWrapper data-testid='display-contract-modal'>
      <ContractModal
        modalIsOpen={props.shouldOpenModal}
        setIsOpen={props.setShouldOpenModal}
        closedDealId={props.closedDealId}
        chromeId={props.chromeId}
        dealerId={props.dealerId}
      />
    </DealSheetWrapper>
  );
};
